<script setup lang="ts">
const props = defineProps<{
  isProcessing: boolean
  isPointsModalOpen: boolean
  pointsToSet: number | null | string
  currentPoints: number
}>()
const { t } = useI18n()

const emit = defineEmits<{
  (e: 'onClose'): void
  (e: 'onConfirm'): void
}>()

const modalTexts = computed(() => {
  return {
    title: t(
      `pages.customer.customerDetailPage.blocks.points.modal.title.${Number(props.pointsToSet) < 0 ? 'remove' : 'add'}`,
      { points: Number(props.pointsToSet) },
      Number(Math.abs(Number(props.pointsToSet))) > 1 ? 2 : 1
    ),
    confirm: t('pages.customer.customerDetailPage.blocks.points.modal.confirm'),
    cancel: t('global.words.cancel')
  }
})
</script>

<template>
  <BaseModal
    :is-open="isPointsModalOpen"
    :link-text="modalTexts.confirm"
    :cancel="modalTexts.cancel"
    icon="HeroExclamationTriangleIconSolid"
    icon-color="yellow"
    :is-processing="isProcessing"
    @close="emit('onClose')"
    @click="emit('onConfirm')"
  >
    <div class="text-xl font-medium leading-6 text-foreground">{{ modalTexts.title }}</div>
    <div class="my-6 flex items-center justify-between bg-muted p-5 text-foreground">
      <div>
        {{ t('pages.customer.customerDetailPage.blocks.points.modal.actual') }}
        <span class="font-bold">{{ currentPoints }}</span>
      </div>
      <BaseIcon name="HeroArrowLongRightIconSolid" class="h-6 w-6 text-muted-foreground" />
      <div>
        {{ t('pages.customer.customerDetailPage.blocks.points.modal.new') }}
        <span class="font-bold">{{ Number(currentPoints) + Number(pointsToSet) }}</span>
      </div>
    </div>
  </BaseModal>
</template>
